import { useParams } from "react-router-dom";
import React, { lazy, Suspense } from "react";
import { ErrorBoundary } from "pages/ErrorState";

function loadComponent(importPath: string | undefined, importSubPath: string | undefined) {
    if (importSubPath != null) {
        const Component = lazy(() => import(`./Content/${importPath}/${importSubPath}`));
        return Component;
    }
    const Component = lazy(() => import(`./Content/${importPath}`));
    return Component;
}

function HelpPage() {
    const { helpTopic, helpSubTopic } = useParams();

    const TargetComponent = loadComponent(helpTopic, helpSubTopic);
    return (
        <Suspense fallback={<div>loading....</div>}>
            <ErrorBoundary>
                <TargetComponent />
            </ErrorBoundary>
        </Suspense>
    );
}

export default HelpPage;
